const PUBLIC_UI_PATHS = new Set(['/', '/login', '/impressum', '/datenschutz', '/maintenance']);
const PREVIEW_PATHS = ['/dev', '/customer-portal', '/share', '/status'];

export function isProductionPreviewPath(pathname: string): boolean {
  return PREVIEW_PATHS.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}

export function isPublicUiPath(pathname: string, environment = process.env.NODE_ENV): boolean {
  return PUBLIC_UI_PATHS.has(pathname) || (environment !== 'production' && isProductionPreviewPath(pathname));
}
